var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_685",
    "data-name": "Groupe 685",
    transform: "translate(-168 -317)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(168 317)",
    fill: "#19c3b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_676",
    "data-name": "Groupe 676",
    transform: "translate(172.001 323.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_189",
    "data-name": "Trac\\xE9 189",
    d: "M18.775,35a1.956,1.956,0,0,1-1.387-.575L7.575,24.613a1.961,1.961,0,0,1,2.774-2.774l8.426,8.426L38.964,10.076a1.961,1.961,0,0,1,2.774,2.774L20.162,34.426A1.956,1.956,0,0,1,18.775,35Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ab65d92c7aa154161e012726b27152fb.svg";
export { ForwardRef as ReactComponent };